import { neutral, brandAlt } from '../global';
export const brandAltBackground = {
    primary: brandAlt[400],
    ctaPrimary: neutral[7],
    ctaPrimaryHover: '#454545',
    ctaSecondary: brandAlt[200],
    ctaSecondaryHover: '#F2AE00',
    ctaTertiaryHover: '#FFD213',
};
//# sourceMappingURL=brand-alt.js.map
